module.exports = require("socket.io-client");